// App.js
import React from 'react';
import { Dino } from 'react-dino-game';

function DinoGamePlayer() {
  return (
    <div>
      <Dino />
    </div>
  );
}

export default DinoGamePlayer;